import { getBrokerFlow } from './getBrokerFlow';
import { IApplicationState } from '../../types/redux';

export const getBrokerPartnerRewardsLanding = (state: IApplicationState): string | null => {
  const pageFlowType = getBrokerFlow(state);
  const isPartnerRewardsRegistered = state.newbuilding?.newbuildingBroker?.isPartnerRewardsRegistered;

  if (pageFlowType === 'withPartnerRewards' && !isPartnerRewardsRegistered) {
    return state.newbuilding?.newbuildingBroker?.partnerRewardsFlowUrl || null;
  }

  return null;
};
